import { useEffect } from 'react';

export const useLogging = (
  componentName: string,
  dependencies: any = []
) => {
  useEffect(() => {
    console.log(`[mount] ${componentName}`);

    return () => console.log(`[unmount] ${componentName}`);
  }, [componentName]);

  useEffect(() => {
    console.log(`[update] ${componentName}`, dependencies);
  }, [componentName, ...dependencies]);
}
